var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_3708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_142_3708",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.640625 0.25H20.8906V18.25H0.640625V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_142_3708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8836 9.23242C20.8836 9.86523 20.3562 10.3609 19.7586 10.3609H18.6336L18.6582 15.993C18.6582 16.0879 18.6512 16.1828 18.6406 16.2777V16.8438C18.6406 17.6207 18.0113 18.25 17.2344 18.25H16.6719C16.6332 18.25 16.5945 18.25 16.5559 18.2465C16.5066 18.25 16.4574 18.25 16.4082 18.25H15.2656H14.4219C13.6449 18.25 13.0156 17.6207 13.0156 16.8438V16V13.75C13.0156 13.1277 12.5129 12.625 11.8906 12.625H9.64062C9.01836 12.625 8.51562 13.1277 8.51562 13.75V16V16.8438C8.51562 17.6207 7.88633 18.25 7.10938 18.25H6.26562H5.14414C5.09141 18.25 5.03867 18.2465 4.98594 18.243C4.94375 18.2465 4.90156 18.25 4.85938 18.25H4.29688C3.51992 18.25 2.89062 17.6207 2.89062 16.8438V12.9062C2.89062 12.8746 2.89062 12.8395 2.89414 12.8078V10.3609H1.76562C1.13281 10.3609 0.640625 9.86875 0.640625 9.23242C0.640625 8.91602 0.746094 8.63477 0.992188 8.38867L10.0062 0.53125C10.2523 0.285156 10.5336 0.25 10.7797 0.25C11.0258 0.25 11.307 0.320312 11.518 0.496094L20.4969 8.38867C20.7781 8.63477 20.9187 8.91602 20.8836 9.23242Z",
    fill: "#9CA3AF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_3708"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V19H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.08f54d3781e27f8a1934f2a108238f22.svg";
export { ForwardRef as ReactComponent };